import bowser from 'bowser';
import { isDefined } from 'remeda';

export function getBrowser() {
  return bowser.parse(navigator.userAgent).browser;
}

export function getPlatform() {
  return bowser.parse(navigator.userAgent).platform;
}

export function getEnvironmentStats(): string[] {
  if (typeof window === 'undefined') {
    return [];
  }

  const browser = bowser.parse(window.navigator.userAgent);

  return [
    browser.os.name,
    browser.platform.model,
    browser.browser.name,
    browser.engine.name,
    browser.browser.version,
  ].filter(isDefined);
}

export const isBrowserBelowSupportedVersion = () => {
  try {
    const ua = navigator?.userAgent;
    let browser: string | undefined, versionMatch: RegExpMatchArray | null;

    if (/chrome|crios/i.test(ua) && !/edge|opera|samsung/i.test(ua)) {
      browser = 'chrome';
      versionMatch = ua.match(/Chrome\/(\d+)/i);
      if (browser && versionMatch && versionMatch[1]) {
        return parseInt(versionMatch[1], 10) < 125;
      }
    }

    if (/edg/i.test(ua)) {
      browser = 'edge';
      versionMatch = ua.match(/Edg\/(\d+)/i);
      if (browser && versionMatch && versionMatch[1]) {
        return parseInt(versionMatch[1], 10) < 125;
      }
    }

    if (/firefox|fxios/i.test(ua)) {
      browser = 'firefox';
      versionMatch = ua.match(/Firefox\/(\d+)/i);
      if (browser && versionMatch && versionMatch[1]) {
        return parseInt(versionMatch[1], 10) < 124;
      }
    }

    if (/opr|opera/i.test(ua)) {
      browser = 'opera';
      versionMatch = ua.match(/OPR\/(\d+)/i);
      if (browser && versionMatch && versionMatch[1]) {
        return parseInt(versionMatch[1], 10) < 111;
      }
    }

    if (/safari/i.test(ua) && !/chrome|crios|android/i.test(ua)) {
      browser = 'safari';
      versionMatch = ua.match(/Version\/(\d+)(\.\d+)?/);
      if (browser && versionMatch && versionMatch[1]) {
        return parseFloat(versionMatch[1]) < 17.3;
      }
    }

    if (/samsung/i.test(ua)) {
      browser = 'samsung-internet';
      versionMatch = ua.match(/SamsungBrowser\/(\d+)/i);
      if (browser && versionMatch && versionMatch[1]) {
        return parseInt(versionMatch[1], 10) < 27;
      }
    }

    if (/android/i.test(ua) && /chrome/i.test(ua)) {
      browser = 'chrome-android';
      versionMatch = ua.match(/Chrome\/(\d+)/i);
      if (browser && versionMatch && versionMatch[1]) {
        return parseInt(versionMatch[1], 10) < 125;
      }
    }

    if (/firefox/i.test(ua) && /android/i.test(ua)) {
      browser = 'firefox-android';
      versionMatch = ua.match(/Firefox\/(\d+)/i);
      if (browser && versionMatch && versionMatch[1]) {
        return parseInt(versionMatch[1], 10) < 124;
      }
    }

    if (/opr|opera/i.test(ua) && /android/i.test(ua)) {
      browser = 'opera-android';
      versionMatch = ua.match(/OPR\/(\d+)/i);
      if (browser && versionMatch && versionMatch[1]) {
        return parseInt(versionMatch[1], 10) < 83;
      }
    }

    if (/iphone|ipad|ipod/i.test(ua) && /safari/i.test(ua)) {
      browser = 'safari-ios';
      versionMatch = ua.match(/Version\/(\d+)(\.\d+)?/);
      if (browser && versionMatch && versionMatch[1]) {
        return parseFloat(versionMatch[1]) < 17.3;
      }
    }

    if (/wv/i.test(ua) || /Android.*AppleWebKit/i.test(ua)) {
      browser = 'webview-android';
      versionMatch = ua.match(/Chrome\/(\d+)/i);
      if (browser && versionMatch && versionMatch[1]) {
        return parseInt(versionMatch[1], 10) < 125;
      }
    }
    return false;
  } catch (e) {
    console.error('Error in isBrowserBelowSupportedVersion', JSON.stringify(e));
    return false;
  }
};
